import Component from './Component';
import * as PIXI from 'pixi.js';
import Point from '../Utility/Point';
import Text from '../Prototype/Text';

export default class TextBoundaryComponent extends Component<PIXI.Text, Text> {
    set bounds(value: Point) {
        // Validate.
        if (!value || value.x <= 0 || value.y <= 0) return;

        // Try until get a fitable fontSize.
        for (
            let fontSize =
                parseInt(this.container.style.fontSize as string) - 1;
            fontSize > 0;
            fontSize--
        ) {
            const metrics = PIXI.TextMetrics.measureText(
                this.container.text,
                this.container.style
            );

            if (metrics.width > value.x || metrics.height > value.y) {
                this.container.style.fontSize = fontSize;
            } else {
                break;
            }
        }
    }
}
